<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
      
    >
      <v-card>
        <v-card-title primary-title>
          Editar mi perfil
        </v-card-title>
        <v-card-text primary-title justify-center>
          <v-layout row wrap justify-center>
            <v-flex xs6>
              <label>Nombre</label>
              <v-text-field
                name="name"
                label="Nombre"
                id="id"
                solo
                v-model="formData.name"
              ></v-text-field>          
            </v-flex>
            <v-flex xs6>
              <label>Correo Electronico</label>
              <v-text-field
                name="name"
                label="Correo electronico"
                id="id"
                solo
                v-model="formData.email"
              ></v-text-field>     
            </v-flex>
            <v-flex xs6>
              <label>Cambiar contraseña</label>             
              <v-text-field
                  name="password"
                  label="Nueva Contrseña"
                  id="password"
                  solo
                  v-model="formData.password"
                  :type="type ? 'password' : 'text'"
                  :append-icon="type ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  @click:append="type = !type"
                ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-btn color="success" @click="updateProfile()">Actualizar mi perfil</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          
        </v-card-actions>
      </v-card>
    </v-layout>
    <v-snackbar :color="alert.color"
      v-model="alert.active"
    >
      {{ alert.message }}
      <v-btn text @click.native="alert.active = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  created() {
     this.setProfile()
  },
  data(){
    return{
      formData: {
          name: '',
          email: '',
          password: '',
        },
        type: true,
        baseRoute: process.env.VUE_APP_URL + 'api/', 
        alert: {
          active: false,
          message: '',
          color: ''
        }
      }
  },
  methods:{
    setProfile(){
      this.formData.name = this.$store.state.api.user.name
      this.formData.email = this.$store.state.api.user.email
      this.formData.id = this.$store.state.api.user.id
    },
    updateProfile(){
      axios.post(this.baseRoute + 'user/updateProfile', this.formData).then((res) => {
        this.alert.active = true;
        this.alert.message = "Su perfil fue cambiado exitosamente";
        this.alert.color = "success";
        this.formData.password = '';
      }).catch((error) => {
        this.alert.active = true;
        this.alert.message = "Hubó un error interno en el servidor, pruebe nuevamente mas tarde";
        this.alert.color = "error";
      });
    }
  }
}
</script>
